import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceField,
  Show,
  SimpleShowLayout,
  ReferenceInput,
  Edit, required, email,
  EmailField,
  AutocompleteInput, Filter, NullableBooleanInput,
  SelectField,
  useGetOne,
  // useNotify
} from 'react-admin';

const choices = [
  { id:1, name: 'User'},
  { id:2, name: 'Pilot'},
  { id:4, name: 'Internal'},
  { id:255, name: 'Admin'}
];

function UsersList(props: any) {
  return (
    <List {...props} title="Users" filters={<UserFilter/>} sort={{field: 'name', order: 'ASC'}}>
      <Datagrid rowClick="show">
        <TextField source="name"/>
        <ReferenceField label="Customer" source="customerId" reference="customers" link="show">
          <TextField source="companyName"/>
        </ReferenceField>
        <TextField source="role"/>
        <EmailField source="email"/>
        <BooleanField source="isActive"/>
        <BooleanField source="isAdmin"/>
        <SelectField source="permission" choices={choices}/>
        <EditButton/>
      </Datagrid>
    </List>
  )
}

export const UserShow = (props: any) => (
  <Show title="User details" {...props} >
    <SimpleShowLayout>
      <TextField source="name"/>
      <ReferenceField label="Customer" source="customerId" reference="customers">
        <TextField source="companyName"/>
      </ReferenceField>
      <TextField source="role"/>
      <EmailField source="email"/>
      <BooleanField source="isActive"/>
      <BooleanField source="isAdmin"/>
      <SelectField source="permission" choices={choices}/>
    </SimpleShowLayout>
  </Show>
);

export const UserCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" validate={[required()]}/>
      <TextInput source="role"/>
      <TextInput source="email" validate={[required(), email()]}/>
      <ReferenceInput source="customerId" reference="customers" validate={[required()]} perPage={1000} sort={{field: 'companyName', order: 'ASC'}}>
        <AutocompleteInput optionText="companyName"/>
      </ReferenceInput>
      <BooleanInput source="isActive"/>
      <BooleanInput source="isAdmin"/>
      <AutocompleteInput source="permission" choices={choices} validate={[required()]} />
    </SimpleForm>
  </Create>
);


export const UserEdit = (props: any) => {
  const {data} = useGetOne('users', props.id);
  // const notify = useNotify();
  const change = (permission: number) => {
    if(permission > 2 && data && !(data.email.includes('@eos.info')))
    {
      console.log("Warning this role might not be corred");
      //SCHLMI 25.03.2022 to use notification we must add a translation provider.
      
      // const permEntry = choices.find(x => x.id === permission);
      // if(permEntry)
      //   notify(`Caution - you assign the role ${permEntry.name} to a non @eos.info mail address ${data.email}!`, 'info', undefined);
    }
  };
  return (
    <Edit {...props}>
    <SimpleForm >
      <TextInput source="name" validate={[required()]}/>
      <TextInput source="role"/>
      <TextInput source="email" disabled />
      <ReferenceInput source="customerId" reference="customers" validate={[required()]} perPage={1000} sort={{field: 'companyName', order: 'ASC'}}>
        <AutocompleteInput optionText="companyName"/>
      </ReferenceInput>
      <BooleanInput source="isActive"/>
      <BooleanInput source="isAdmin"/>
      <AutocompleteInput source="permission" choices={choices} validate={[required()]} onChange={change} />
    </SimpleForm>
  </Edit>)

};

const UserFilter = (props: any) => (
      <Filter {...props}>
        <TextInput label="Search" source="search" alwaysOn variant="outlined"/>
        <TextInput source="name" variant="outlined" />
        <ReferenceInput label="Customer" source="customerId" reference="customers" variant="outlined" >
          <AutocompleteInput optionText="companyName"/>
        </ReferenceInput>
        <TextInput source="email" variant="outlined" />
        <TextInput source="role" variant="outlined" />
        <NullableBooleanInput source="isActive" variant="outlined" />
        <NullableBooleanInput source="isAdmin" variant="outlined" />
      </Filter>
)

export default UsersList